
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { glyphs } from "../../../Styles";
import { NewSelectList, NewInputList, NewModal, MainContentPaddingTypes, NewSelect, NewButton, NewInput } from "../..";
import { ButtonTypes, ListStyle_Types, NewSelectHandles, NewInputListHandles, NewSelectListHandles, ValueType, NewInputHandles } from "../../../Definitions";
import { useFeedcurveOptions, useGroupOptions, useSectionOptions } from "../../_Components";
import { Graph_QL, useAnimal } from "../../../Services";
import { useAppSelector } from "../../../Store";
import { selectAllFeedCurveMilestoneOptions } from "../../../Store/OptionsHandlers/optionsCombinedReducer";

interface AddAnimalModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
  connect: {
    domain: string;
    connection: Graph_QL.Connection;
  }
}

export default function AddAnimalModal({ isModalOpen, closeModal, connect }: AddAnimalModal_Props) {
  const { t } = useTranslation()
  const [message, setMessage] = useState<string | null>(null)
  const groupOptions = useGroupOptions()
  const { feedCurveOptions } = useFeedcurveOptions()
  const sectionOptions = useSectionOptions()
  const [selectedFeedCurve, setSelectedFeedCurve] = useState<number | undefined>(undefined);
  const [selectedMilestone, setSelectedMilestone] = useState<number | undefined>(undefined);
  const [selectedMilestoneDay, setSelectedMilestoneDay] = useState<number | undefined>(undefined);

  const inputRefs = useRef<NewInputListHandles>(null);
  const selectRefs1 = useRef<NewSelectListHandles>(null);
  const selectRefs2 = useRef<NewSelectListHandles>(null);

  const { call: getAnimals, data: animalState, createAnimals: createAnimal } = useAnimal(connect.connection);

  useEffect(() => {
    if (!animalState[connect.domain]?.data) {
      getAnimals({})
    }
  }, [animalState, connect.domain, getAnimals])

  const animals = useMemo(() => {
    return animalState[connect.domain]?.data
  }, [animalState, connect.domain])

  const feedCurveMilestones = useAppSelector(selectAllFeedCurveMilestoneOptions).reduce((agg, milestone) => {
    const { feedCurveId } = milestone;
    agg[feedCurveId] = agg[feedCurveId] || []
    agg[feedCurveId].push(milestone)
    return agg;
  }, {} as { [key: number]: (ValueType & { feedCurveId: number; index: number; milestoneId: number; })[] });
  const milestoneOptions = feedCurveMilestones[Number(selectedFeedCurve)] ?? []

  console.log(selectedMilestone)

  const handleCreate = () => {
    if (inputRefs && inputRefs.current && inputRefs.current.refs.current) {
      const animalNumber = +inputRefs.current.refs.current[0].value;
      const responderNumber = inputRefs.current.refs.current[1].value === "" ? undefined : inputRefs.current.refs.current[1].value + "";
      const lifeNumber = inputRefs.current.refs.current[2].value === "" ? undefined : +inputRefs.current.refs.current[2].value + "";
      let location_id;
      let group;
      // let condition;
      // let type;
      let feedCurve;

      if (selectRefs1 && selectRefs1.current && selectRefs1.current.refs.current) {
        location_id = selectRefs1.current.refs.current[0]?.value.id ? Number(selectRefs1.current.refs.current[0]?.value.id) : undefined;
        group = selectRefs1.current.refs.current[1]?.value.id
      }

      if (selectRefs2 && selectRefs2.current && selectRefs2.current.refs.current) {
        // condition = selectRef.current.refs.current[0]?.value.id
        // type = selectRefs.current.refs.current[1]?.value.id
        feedCurve = selectRefs2.current.refs.current[2]?.value.id
      }

      const milestoneDayTimestamp = Math.floor((Date.now() - Number(selectedMilestoneDay) * 86400000) / 1000)

      if (!animalNumber) {
        // inputRef.current.refs.current[0].setError()
        setMessage(t("animalPages.animals.missingAnimalNo", { defaultValue: "animal no. is missing" }))
      } else if (animals.some(a => a.animal_number === animalNumber)) {
        setMessage(t("animalPages.animals.duplicatedAnimalNo", { defaultValue: "the animal number is already used" }))
      } else if (responderNumber && animals.some(a => a.responder_number === responderNumber)) {
        // inputRef.current.refs.current[1].setError()
        setMessage(t("animalPages.animals.duplicatedResponderNo", { defaultValue: "the responder number is already used" }))
      } else if (responderNumber && responderNumber?.length !== 15) {
        setMessage(t("animalPages.animals.responderLengt", { defaultValue: "the responder number must be 15 characters" }))
      } else if (lifeNumber && lifeNumber?.length > 9) {
        setMessage(t("animalPages.animals.lifeNoLengt", { defaultValue: "the life number must not exceed 9 characters" }))
      } else {
        if (createAnimal) {
          createAnimal([{
            animal_number: animalNumber,
            responder_number: responderNumber, // TODO send null instead of 0
            life_number: Number(lifeNumber),
            location_id,
            animal_group_id: Number(group),
            // condition: condition,
            // animal_type: Number(type),
            feedcurve_id: Number(feedCurve),
            milestone_id: selectedMilestone,
            milestone_day: milestoneDayTimestamp
          }])
          closeModal();
        }
      }
      setTimeout(() => {
        setSelectedMilestone(undefined);
        setSelectedFeedCurve(undefined);
        setSelectedMilestoneDay(undefined);
        setMessage(null);
      }, 2000);
    }
  }

  return (
    <NewModal
      modalState={isModalOpen}
      header={t("animalPages.animals.newAnimal", { defaultValue: "New Animal" })}
      predefinedButtons={{
        onClose: () => { closeModal(); setSelectedMilestone(undefined); setSelectedFeedCurve(undefined) },
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      mainContent={
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "center", columnGap: "40px", rowGap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <NewInputList
              ref={inputRefs}
              headers={[t("params.animalId", { defaultValue: "animal no." }), t("params.responderNo", { defaultValue: "responder no." }), t("params.lifeNo", { defaultValue: "life no." })]}
              startEnhancers={[glyphs.AnimalNumber({}), glyphs.ResponderNumber({}), glyphs.LifeNumber({})]}
              placeholders={["", "", ""]}
              isRequired={[true, false, false]}
              valueOverrides={{
                valueTypes: ["number", "number", "number"],
                maxValueNumbers: [undefined, undefined, 999999999]
              }}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
            />
            <NewSelectList
              ref={selectRefs1}
              placeholders={["", ""]}
              headers={[t("params.location", { defaultValue: "location" }), t("params.group", { defaultValue: "group" })]}
              startEnhancers={[glyphs.Location({}), glyphs.AnimalGroup({})]}
              options={[sectionOptions.locationOptions ?? [], groupOptions ?? []]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <NewSelectList
              isDisabled={[true, true, false, selectedFeedCurve === undefined]}
              placeholders={["", "", "", ""]}
              ref={selectRefs2}
              startEnhancers={[glyphs.Condition({}), glyphs.AnimalType({}), glyphs.FeedCurve({}), glyphs.Milestone({}),]}
              headers={[t("params.condition", { defaultValue: "condition" }), t("params.animalType", { defaultValue: "animal type" }), t("params.feedCurve", { defaultValue: "feed curve" }), t("params.milestone", { defaultValue: "milestone" })]}
              options={[[], [], feedCurveOptions ?? [], milestoneOptions]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
              onChanges={[
                () => { },
                () => { },
                (selectedOption) => {
                  const fcId = selectedOption?.id;
                  setSelectedFeedCurve(Number(fcId));

                  const firstMilestone = feedCurveMilestones[Number(fcId ?? -1)]?.[0];
                  setSelectedMilestone(firstMilestone?.milestoneId);

                  setSelectedMilestoneDay(
                    firstMilestone?.milestoneId !== undefined ? 0 : undefined
                  );
                },
                (selectedOption) => {
                  const feedCurveMilestoneId = Number(selectedOption?.id);
                
                  const selectedMilestoneOption = milestoneOptions.find(
                    milestone => milestone.id === feedCurveMilestoneId
                  );
                
                  setSelectedMilestone(selectedMilestoneOption?.milestoneId);
                
                  setSelectedMilestoneDay(
                    selectedMilestoneOption?.milestoneId !== undefined ? 0 : undefined
                  );
                }
              ]}
              valueOverrides={{
                defaultValues: [undefined, undefined, undefined, selectedFeedCurve !== undefined ? milestoneOptions[0] : undefined]
              }}
            />
            <NewInput
              header={t("params.milestone_day", { defaultValue: "milestone day" })}
              startEnhancer={glyphs.MilestoneDay({})}
              valueOverrides={{
                minValueNumber: 0,
                valueType: "number",
                defaultValue: selectedMilestoneDay
              }}
              onChange={(value) => {
                setSelectedMilestoneDay(Number(value));
              }}
              isDisabled={selectedFeedCurve === undefined}
            />
          </div>
        </div>
      }
      footerMessage={message ?? ""}
      footerContent={
        <NewButton
          content={t("buttons.create", { defaultValue: "create" })}
          buttonType={ButtonTypes.primaryButton}
          onClick={() => { handleCreate() }}
        />
      }
    />
  );
}